export const confirmationCheck = (enabled, question, callback) => {
  if (!enabled) return callback();
  const result = confirm(question);
  return result ? callback() : null;
};
